import React from 'react';
import { BrButton, BrModal, BrScrim } from "@govbr-ds/webcomponents-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

export const ConfirmationModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = "Confirmação", 
    message, 
    icon = faQuestionCircle,
    confirmText = "Confirmar",
    cancelText = "Recusar"
}) => {
    return (
        <BrScrim isOpen={isOpen} onBrScrimClose={onClose}>
            <BrModal
                titleText={title}
                alignFooter="end"
                size="medium"
                scrim={true}
                show={isOpen}
                onBrModalClose={onClose}
                scrollable={false}
            >
                <div slot="header" className="d-flex align-items-center">
                    <FontAwesomeIcon icon={icon} size="2x" className="mr-1 color-primary text-primary"/> 
                    <span>{title}</span>
                </div>
                <p>{message}</p>
                
                <div slot="footer">
                    <BrButton emphasis="secondary" className="mr-1" onClick={onClose}>{cancelText}</BrButton>							
                    <BrButton emphasis="primary" onClick={onConfirm}>{confirmText}</BrButton>
                </div>
            </BrModal>
        </BrScrim>
    );
};
